import {
  ReinvoiceRequestModel,
  SettlementBatchModel,
  SettlementBatchRequestModel
} from '../../api/Argentia/endpoints/settlementBatchs/model/settlementBatchs'
import {
  apiGetSettlementBatchsObjections,
  apiPostReinvoiceBatch,
  apiPostSettlementBatch
} from '../../api/Argentia/endpoints/settlementBatchs/settlementBatchs.api'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../../helpers/serviceResponseHelper'
import { ServiceResponse } from '../../model/serviceResponse'
import { ObjectionsModel } from '../invoicesPage/invoicesPage.Model'

export const getSettlementBatchsObjections = async (
  executionCycleId: number
): Promise<ServiceResponse<ObjectionsModel[] | undefined>> => {
  return await apiGetSettlementBatchsObjections(executionCycleId)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const createSettlementBatch = async (
  request: SettlementBatchRequestModel
): Promise<ServiceResponse<SettlementBatchModel | undefined>> => {
  return await apiPostSettlementBatch(request)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const createReinvoiceBatch = async (
  request: ReinvoiceRequestModel
): Promise<ServiceResponse<SettlementBatchModel | undefined>> => {
  return await apiPostReinvoiceBatch(request)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}
